import "core-js/modules/es.array.concat";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.replace";
import _objectSpread from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { isNewQQLogin } from './login';
import { buildCSRF } from './login/lib';
export var RequestErrorType = {
  NETWORK_ERR: 'NETWORK_ERR',
  SYSTEM_ERR: 'SYSTEM_ERR',
  LOGIC_ERR: 'LOGIC_ERR'
};
var IS_STD_PROTOCOL = /^(http|https):$/.test(location.protocol);
var HTTP2HTTP_PROXY = 'https://access.video.qq.com/trans/';
var HTTP2HTTP_APPID = '68106135';
var HTTP2HTTP_SECRETKEY = 'e667570eb833960cc41051d498df1c233308eb195dba2cc3';
/**
 * 通用的请求错误描述类
 * @param code
 * @param msg
 * @param res
 * @constructor
 */

export function RequestError(code, msg, res, errorType) {
  this.code = code;
  this.msg = msg;
  this.res = res;
  this.errorType = errorType || RequestErrorType.LOGIC_ERR;
}

RequestError.prototype.toString = function () {
  return this.msg + (this.code ? "(".concat(this.code, ")") : '');
};

RequestError.prototype.RequestErrorType = RequestError.RequestErrorType = RequestErrorType;
/**
 * 通用请求
 * @param url
 * @param data
 * @param options zepto.js ajax的其他option 如 timeout 具体查看 http://zeptojs.com/#$.ajax
 * @return Promise
 */

export function request(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (isNewQQLogin() && url.match(/\/\/pay.video.qq.com/)) {
    // QQ互联迁移
    url = url.replace(/\/\/(pay.video.qq.com)/, '//access.video.qq.com/trans/$1');

    if (!$.isPlainObject(data)) {
      data = {};
    }

    var csrfParam = buildCSRF();
    $.extend(data, {
      vappid: HTTP2HTTP_APPID,
      vsecret: HTTP2HTTP_SECRETKEY
    }, csrfParam);
  }

  if (!IS_STD_PROTOCOL && /^\/\//.test(url)) {
    url = "https:".concat(url);
  }

  return new Promise(function (resolve, reject) {
    $.ajax($.extend({
      url: url,
      dataType: 'jsonp',
      data: data,
      success: function success(json) {
        if (json) {
          resolve(json);
        } else {
          reject(new RequestError(0, '服务器开小差了！请重试', null, RequestErrorType.NETWORK_ERR));
        }
      },
      error: function error() {
        reject(new RequestError(0, '网络开小差了！请重试', null, RequestErrorType.NETWORK_ERR));
      }
    }, options));
  });
}
export function nRequest(url) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return request(_formatNodeAPIUrl(url, args), null, {
    dataType: 'json'
  }).then(function (_ref) {
    var ret = _ref.ret,
        msg = _ref.msg,
        data = _ref.data;

    if (ret !== 0) {
      throw new RequestError(ret, msg, null, RequestErrorType.LOGIC_ERR);
    }

    return data;
  });
}

function _formatNodeAPIUrl(url, args) {
  if (!args.length) {
    return url;
  }

  var i = 0;
  return url.replace(/%(s|n)/g, function (m) {
    var v = args[i++];

    if (v === undefined || v === null) {
      v = '';
    }

    switch (m) {
      case '%n':
        return v;

      case '%s':
      default:
        return "\"".concat(v, "\"");
    }
  });
}

export function http2http(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return request("".concat(HTTP2HTTP_PROXY).concat(url.replace(/^(https:|http:)?\/\//, '')), _objectSpread(_objectSpread({}, params), {}, {
    vappid: HTTP2HTTP_APPID,
    vsecret: HTTP2HTTP_SECRETKEY
  }, buildCSRF()), options);
}
export function commConfig(configId) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return commCGI({
    name: 'spp_get_confi',
    cmd: 1
  }, _objectSpread({
    config_id: configId
  }, params), options);
}
export function commCGI(_ref2) {
  var name = _ref2.name,
      cmd = _ref2.cmd;
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var isJson = options.dataType && options.dataType.toLowerCase() === 'json';

  if (options.withCredentials === true) {
    options = _objectSpread({
      xhrFields: {
        withCredentials: true
      }
    }, options);
  }

  return request("https://vip.video.qq.com/fcgi-bin/comm_cgi?name=".concat(name, "&cmd=").concat(cmd, "&otype=").concat(isJson ? 'xjson' : 'json'), params, options).then(function (res) {
    if (res && res.ret === -10) {
      throw new RequestError(res.ret, "CommCGI\u540D\u79F0\u672A\u914D\u7F6E(name=".concat(name, ")"), res, RequestErrorType.SYSTEM_ERR);
    }

    return res;
  });
}
/**
 * rpcCGI 支持调用 rpcGo 的接口
 * @param {string} path rpc路由
 * @param {object} params 参数
 * @param {object} options 请求设置
 * @example
 * // 请求接口 http://vip.video.qq.com/rpc/trpc.kidsvip.checkinfo.KidsVipService/KidsVipCheckInfo
 * try {
 *   await rpcCGI('trpc.kidsvip.checkinfo.KidsVipService/KidsVipCheckInfo')
 * } catch (e) {
 * }
 */

export function rpcCGI() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  options = _objectSpread({
    type: options.type || 'post'
  }, options);

  if (options.type.toLowerCase() === 'post') {
    options.dataType = 'json';
    options.contentType = "text/plain;charset=utf-8";
    options.xhrFields = {
      withCredentials: true
    };
    data = JSON.stringify(data);
  }

  var url = "//vip.video.qq.com/rpc/".concat(path);

  if (path.match(/^(https?:)?\/\//)) {
    url = path;
  }

  if (!IS_STD_PROTOCOL && /^\/\//.test(url)) {
    url = "https:".concat(url);
  }

  return new Promise(function (resolve, reject) {
    $.ajax(_objectSpread(_objectSpread({
      url: url,
      data: data
    }, options), {}, {
      success: function success(data, status, xhr) {
        if (!data) {
          reject(new RequestError(xhr.getResponseHeader('trpc-func-ret'), xhr.getResponseHeader('trpc-error-msg'), null, RequestErrorType.SYSTEM_ERR));
        } else {
          resolve(data);
        }
      },
      error: function error(xhr, status) {
        reject(new RequestError(xhr.getResponseHeader('trpc-func-ret') || -999, xhr.getResponseHeader('trpc-error-msg') || status, null, RequestErrorType.NETWORK_ERR));
      }
    }));
  });
}